import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';
// import '../styles/style.main.min.css';
import HomePageComponent from '../Templates/HomePageComponent';
import {
  data as pageDataJSON,
} from '../data/homePageData.json';
import {getCanonicalPages} from './Shared/Utils';

const HomePage = ({data}) => {
  const canonicalPages = getCanonicalPages(
      data.brandWebsiteHomepage.url,
  );
  const pageData = {
    ...data,
    ...pageDataJSON,
    canonicalPages,
  };
  const header = pageData.brandWebsiteHeader;
  const footer = pageData.brandWebsiteFooter;
  const homePage = pageData.brandWebsiteHomepage;
  const imageData = pageData.allS3Object;
  return (
    <HomePageComponent
      key={1}
      headerContent={header}
      footerContent={footer}
      homePageData={homePage}
      languageCanonicals={pageData.canonicalPages}
      siteMetadata={pageData.site.siteMetadata}
      imageData={imageData}
    />
  );
};

HomePage.defaultProps = {
  data: {},
};

HomePage.propTypes = {
  data: PropTypes.object,
};
export default HomePage;

export const pageQuery = graphql`
  query NonEnglishHomePage($id: String,
    $custom_s3KeyArray: [String]
   ) {
    brandWebsiteHomepage(id: { eq: $id }) {
      url
      id
      locale
      title
      sections{
        pagesection {
          title
          content
        }
        herosection {
          checkmarkpointone
          checkmarkpointtwo
          existinguser
          heading
          logincta
          signupcta
          enterprisecta
          subheading
          description
        }
        courselistblock {
          courselist {
            courseslug
            title
            coursemenuname
            coursecarddescription
            coursepreviewvideo {
              title
              href
            }
            url
            seo {
              description
            }
            graduates
            rating
          }
          enrollnowcta
          moreinfocta
          nexttext
          prevtext
          heading
          graduatestext
        }
      }
      seo{
        title
        description
        image {
          title
          href
        }
        canonicalurls {
          title
          href
        }
      }
      schema
    }
  site {
    siteMetadata {
      title
      siteUrl
      description
      social {
        twitter
        facebook
        instagram
        linkedIn
      }
    }
  }
  allS3Object(filter: {Key: {in: $custom_s3KeyArray}}) {
    nodes {
      Key
      localFile {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  }
  }
`;
